module.exports = __webpack_public_path__ + "img/T1_ty_2.6f798341.png";